<template>
  
  <div>
    <PleaseWait class="mt-4" v-if="isLoading" />
    <div v-else class="row reverse-mobile justify-content-center">
      <div class="left-menu col-12 col-md-3">
        <CommunityCard>
          <div class="isim-community-card-header">
            <h5 class="m-0">{{ groupObj.name }}</h5>
          </div>

          <ul class="list-group">
            <a href="javascript:void(0)" @click="currentTab = PAGE_TABS.SETTINGS">
              <li
                  class="list-group-item d-flex align-items-center"
                  v-bind:class="{ active: currentTab === PAGE_TABS.SETTINGS }"
              >
                <i class="material-icons" style="margin-right: 7px">edit</i>Update
                details
              </li>
            </a>
            <a href="javascript:void(0)" @click="currentTab = PAGE_TABS.MEMBERS">
              <li
                  class="list-group-item d-flex align-items-center"
                  v-bind:class="{ active: currentTab === PAGE_TABS.MEMBERS }"
              >
                <i class="material-icons" style="margin-right: 7px">group</i
                >Members
              </li>
            </a>
            <a
                href="javascript:void(0)"
                @click="currentTab = PAGE_TABS.POST_REQUESTS"
            >
              <li
                  class="list-group-item d-flex align-items-center"
                  v-bind:class="{ active: currentTab === PAGE_TABS.POST_REQUESTS }"
              >
                <i class="material-icons" style="margin-right: 7px">email</i>Post
                requests
                <span
                    class="badge badge-pill badge-danger ml-2"
                    v-if="postRequests.length"
                >
                {{ postRequests.length }}
              </span>
              </li>
            </a>
            <a
                href="javascript:void(0)"
                @click="currentTab = PAGE_TABS.JOIN_REQUESTS"
            >
              <li
                  class="list-group-item d-flex align-items-center"
                  v-bind:class="{ active: currentTab === PAGE_TABS.JOIN_REQUESTS }"
              >
                <i class="material-icons" style="margin-right: 7px">group_add</i
                >Join requests
                <span
                    class="badge badge-pill badge-danger ml-2"
                    v-if="joinRequests.length"
                >
                {{ joinRequests.length }}
              </span>
              </li>
            </a>
          </ul>
        </CommunityCard>
      </div>

      <div class="col-12 col-md-9 mb-4 center-content">
        <ForumGroupSettings
            v-if="currentTab === PAGE_TABS.SETTINGS"
            :groupData="groupObj"
            v-on:success="showSuccess"
        />
        <ForumGroupMembers
            v-else-if="currentTab === PAGE_TABS.MEMBERS"
            :groupMembers="groupMembers"
            v-on:success="showSuccess"
            v-on:reload="loadData"
        />
        <ForumJoinRequests
            v-else-if="currentTab === PAGE_TABS.JOIN_REQUESTS"
            :joinRequests="joinRequests"
            v-on:success="showSuccess"
            v-on:reload="loadData"
        />
        <ForumPostRequests
            v-else-if="currentTab === PAGE_TABS.POST_REQUESTS"
            :postRequests="postRequests"
            v-on:success="showSuccess"
            v-on:reload="loadData"
        />

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import ForumGroupSettings from "../components/ForumGroupSettings";
import ForumGroupMembers from "../components/ForumGroupMembers";
import ForumJoinRequests from "../components/ForumJoinRequests";
import ForumPostRequests from "../components/ForumPostRequests";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";
import PleaseWait from "@/components/PleaseWait";

export default {
  name: "EditForumGroup",
  components: {
    PleaseWait,
    ForumGroupSettings,
    ForumGroupMembers,
    ForumJoinRequests,
    ForumPostRequests,
    CommunityCard,
    Footer,
  },
  data: function () {
    return {
      isLoading: false,
      groupObj: {},
      groupMembers: [],
      joinRequests: [],
      postRequests: [],
      PAGE_TABS: {
        SETTINGS: "settings",
        MEMBERS: "members",
        POST_REQUESTS: "postRequests",
        JOIN_REQUESTS: "joinRequests",
      },
      currentTab: "settings",
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      const groupId = this.$route.params.groupId;

      Promise.all([
        forumGroupService.getGroupDetails(groupId),
        forumGroupService.groupJoinRequests(groupId),
        forumGroupService.getPostRequestsForGroup(groupId),
      ]).then((data) => {
        [this.groupObj, this.joinRequests, this.postRequests] = data;
        this.groupMembers = this.groupObj.members;
        this.isLoading = false;
      });
    },
    showSuccess(msg) {
      vm.$swal
        .mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .fire("Success!", msg, "success");
    },
  },
};
</script>

<style>
.list-style-none {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>

<style scoped>
.list-group-item.active {
  color: var(--isim-primary);
}
@media (min-width: 992px) {
  .collapse.dont-collapse-sm {
    display: block;
    height: auto !important;
    visibility: visible;
  }
}

ul.list-group li:not(:first-child a):not(:last-child a) {
  border-radius: 0px;
}

ul.list-group li:first-child a {
  border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

ul.list-group li:last-child a {
  border-top-left-radius: 0px;
  border-top-left-radius: 0px;
}

.list-group-item {
  border: none;
  margin-bottom: 5px;
  margin-left: 0px;
  background: inherit;
  max-height: 2.2rem;
}
</style>
